import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { plantUrls } from "../../URL/ApplicationUrls";
import Plant from "../Plant";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useAddPlant = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (plant: Plant) => {
      return axios.post<number>(plantUrls.addPlant.apiUrl, plant);
    },
    onSuccess: async (response: AxiosResponse<number>) => {
      navigate(plantUrls.plantWithId(response.data).uiPath);
      toast.success(`The plant with the Id ${response.data} has been created`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
